import { useState } from 'react';

// Presentational widget: copies text to the clipboard and flashes confirmation. The "copied" flag is pure
// local widget state (nobody else needs it), so useState is appropriate here (mvvm-view carve-out).
export function CopyButton({ text, label = 'Copy' }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      /* clipboard unavailable (e.g. non-secure context); nothing to surface */
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      className="rounded-md border border-slate-300 px-2 py-1 text-xs font-medium text-slate-600 transition hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
    >
      {copied ? '✓ Copied' : label}
    </button>
  );
}
